export const pageuid = {
  'course-center': '1.2.0',
  'course-detail': '1.3.0',
  'add-purchase': '1.5.0'
}



// WEBPACK FOOTER //
// ./src/defines/pageuid.js